import { storeInstance } from '../store/store';

import getAccessTokenExpirationFromNow from './getAccessTokenExpirationFromNow';
import { authRefreshSuccess, authRefreshFail } from '../actions/authActions';
import { getTeamsAuthToken } from './initTeamsJs';

export const refreshAccessToken = (currentToken?: string) => {
  const dispatch = storeInstance.dispatch;
  const onAuthRefreshSuccess = (newToken: string) => {
    dispatch(authRefreshSuccess(newToken));
    sessionStorage.setItem('accessToken', newToken);
    startAccessTokenRefreshTimer(newToken);
  }
  const onAuthRefreshFail = (error: Error) => {
    dispatch(authRefreshFail(error));

    // retry
    startAccessTokenRefreshTimer(currentToken);
  }
  getTeamsAuthToken(onAuthRefreshSuccess, onAuthRefreshFail);
}

// Starts a timer which fetches a new jwt access token when the provided token 
// is close to expire. If provided token is already expired, it refreshes the token
// immediately.
const startAccessTokenRefreshTimer = (accessToken?: string) => {
  let tokenExpiration = accessToken && getAccessTokenExpirationFromNow(accessToken) || -1;

  // Enable the timer, but assure it runs at least 300ms from now
  // as the timer is reset when the authrefresh fails
  tokenExpiration = tokenExpiration < 300 ? 300: tokenExpiration;
  setTimeout((accessToken: string) => refreshAccessToken(accessToken), tokenExpiration);
}

export default startAccessTokenRefreshTimer;
